import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import Select from 'common/components/form/inputs/Select';
import { components } from 'react-select';
import { useActions } from 'utils/hooks';

import { selectListDefaultOptions } from 'store/lists/selectors';

import * as listActions from 'store/lists/actions';

import _uniqBy from 'lodash/uniqBy';

const ReportsTypeCategorySelector = ({ filter, onChange, isMulti, value, ...rest }) => {
  const [fetchListOptions] = useActions([listActions.fetchListOptions]);

  const reportTypesList = useSelector(state => selectListDefaultOptions(state, 'report-types'));

  const generateReportTypes = useMemo(() => {
    const reportTypes = _uniqBy(reportTypesList, 'category').map(reportType => ({
      ...reportType,
      name: reportType.category
    }));

    return reportTypes;
  }, [reportTypesList]);

  useEffect(() => {
    fetchListOptions('report-types');
  }, []);

  return (
    <Select
      autoFocus={false}
      placeholder="Select value"
      className={`mb-0`}
      options={generateReportTypes}
      getOptionValue={option => option.id}
      getOptionLabel={option => option.name}
      size="sm"
      value={value}
      onChange={(_, v) => onChange(_, v)}
      components={{ Option, SingleValue }}
      {...rest}
    />
  );
};

const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>
    <div className="text-capitalize">{props.data.name}</div>
  </components.SingleValue>
);

const Option = ({ children, ...props }) => (
  <components.Option {...props}>
    <div className="text-capitalize">{props.data.name}</div>
  </components.Option>
);

export default ReportsTypeCategorySelector;
